// extracted by mini-css-extract-plugin
module.exports = {"page-nav":"DashboardTemplate_page-nav__OWnT_"};